import {useTheme } from "@mui/system";
import AdminAPIPage from "../../api/adminAPIs";
import { useEffect, useState } from "react";
import useDisplaySnackbar from "../../utils/useDisplaySnackbar";
import Datatable from "../Common/Datatable";
import useGlobalContext from "../../context/useGlobalContext";
import { getColumns} from "./summaryTableConfig";
import { useMediaQuery } from "@mui/material";
import CommentDialog from "./DilogBox";
import TranscriptView from "./TranscriptView";
import ProgressSpinner from "../Common/ProgressSpinner";
import RegenerateAnalysis from "./RegenerateAnalysis";
import ReanalysisView from "./ReanalysisView";

const generateRows = (meetingSummary: any) =>
  meetingSummary.map((item: any) => ({
    meeting_id: item.meeting_id,
    summary: item.summary,
    email:item.email,
    start_time: item.start_time,
    payload: item.payload,
    reanalysis_exist: item.reanalysis_exist
  }));
  
interface SummaryPageProps {
  startEndMeetingTime: {
    start_time: string;
    end_time: string;
  };
}

const SummaryPage = ({ startEndMeetingTime }: SummaryPageProps) => {
  const [rows, setRows] = useState<any[]>([]);
  const theme = useTheme();
  const isLargeUp = useMediaQuery(theme.breakpoints.up("lg"));
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPayload, setSelectedPayload] = useState<any>(null);
  const [selectedMeetingId, setSelectedMeetingId] = useState<string | null>(null);
  const [regenerateMeetingId, setRegenerateMeetingId] = useState<string | null>(null);
  const [reanalysisMeetingId, setReanalysisMeetingId] = useState<string | null>(null);

  const handleViewClick = (payload: any) => {
    setSelectedPayload(payload);
    setOpenDialog(true);
  };
  const handleTranscriptClick = (meetingId: string) => {
    setSelectedMeetingId(null);
    setTimeout(() => {
      setSelectedMeetingId(meetingId);
    }, 0);
  };
  const handleRegenerateClick = (meetingId: string) => {
    setRegenerateMeetingId(null);
    setTimeout(() => {
      setRegenerateMeetingId(meetingId);
    }, 0);
  };
  const handleReanalysisClick = (meetingId: string) => {
    setReanalysisMeetingId(null);
    setTimeout(() => {
      setReanalysisMeetingId(meetingId);
    }, 0);
  };
  const columns = getColumns(isLargeUp, handleViewClick, handleTranscriptClick, handleRegenerateClick, handleReanalysisClick);
  const [totalRecord, setTotalRecord] = useState(0);
  const { showSnackbar } = useDisplaySnackbar();
  const [showSpinner, setShowSpinner] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(10);
  const { calendar, startEndTime, timeRange } = useGlobalContext();
  const enabled = !!calendar?.calendar_id;
  console.log(pageNumber)
  const {
    isLoading: isDataLoading,
    isFetching: isDataFetching,
    isSuccess,
    isError,
    error,
    data: meetingsData,
  } = AdminAPIPage.useGetMeetingSummary(
    {
      start_time: startEndMeetingTime.start_time,
      end_time: startEndMeetingTime.end_time,
    },
    enabled
  );
  useEffect(() => {
    setShowSpinner(isDataLoading || isDataFetching);
    if (isSuccess) {
      const meetingList = meetingsData?.data?.data;
      setTotalRecord(meetingsData.data.total_records);
      if (meetingList) {
        setRows(generateRows(meetingList));
      }
    }
    if (isError) {
      showSnackbar("error", error);
    }
  }, [isDataLoading, isDataFetching, isSuccess, isError, meetingsData]);
  const onPageChange = (value: number) => {
    setPageNumber(value);
  };

  const onPaginationChange = (pageNumber: number) => {
    onPageChange(pageNumber + 1);
  };
  return (
      <>
        <Datatable
          columns={columns}
          rows={rows}
          rowCount={totalRecord}
          pageSize={pageSize}
          initialSort={() => {}}
          onPaginationChange={onPaginationChange}
          onSortingChange={() => {}}
          onFilterChange={() => {}}
          onGlobalFilterChange={() => {}}
          startEndTime={startEndTime}
          timeRange={timeRange}
          calendarId={calendar?.calendar_id}
        />
        <CommentDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        payload={selectedPayload}
      />
      {selectedMeetingId && <TranscriptView meetingId={selectedMeetingId} />}
      {regenerateMeetingId && <RegenerateAnalysis meetingId={regenerateMeetingId} />}
      {reanalysisMeetingId && <ReanalysisView meetingId={reanalysisMeetingId} />}
       <ProgressSpinner showSpinner={showSpinner} />
      </>  
  );
};

export default SummaryPage;
